import { UPDATE_ACTIVE_SECTION } from '../constants/actionTypes'

export default (state = 0, action) => {
    switch (action.type) {
        case UPDATE_ACTIVE_SECTION:
            return action.payload
        default:
            return state
    }
}
